module.exports = require("./fr-GA.d.ts");